// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"2bf58337","453":"138fd192"}[chunkId] + ".chunk.js";
};